module.exports = __webpack_public_path__ + "img/cover-4.bb1a8c71.jpg";